import { Avatar, Box, Table, Tag, Text } from '@factorialco/deprecated-design-system'
import { AccountMembershipsQuery } from 'generated/resources/graphql'
import buildUrl from 'modules/core/lib/buildUrl'
import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { MembershipAction, MembershipActionsMenu } from './MembershipActionsMenu'
import { useMembershipActions } from './useMembershipActions'
import { statusTagColor, statusTagLabel } from './statusUtils'

type Membership = AccountMembershipsQuery['banking']['accountMemberships'][0]

interface Props {
  membership: Membership
  currentEmployeeId: number
  onboardingAuthorEmployeeId?: number
  onAction: (action: MembershipAction) => void
  actionDisabled?: boolean
}

export const AccountMembershipRow = ({
  membership,
  currentEmployeeId,
  onboardingAuthorEmployeeId,
  onAction,
  actionDisabled,
}: Props) => {
  const isOwner = membership.employee.id === onboardingAuthorEmployeeId
  const tagColor = statusTagColor[membership.status]

  const actions = useMembershipActions({
    membership,
    currentEmployeeId,
    onboardingAuthorEmployeeId,
  })

  return (
    <Table.Row>
      <Table.Cell colSpan={6} paddingX="s4">
        <Box flexDirection="row" alignItems="center" gap="s16" minWidth="s96" paddingLeft={'s16'}>
          <Avatar
            size="s40"
            url={buildUrl(membership.employee.avatar?.url)}
            label={membership.employee.fullName}
          />
          <Text.Normal size="200" weight="medium">
            {membership.employee.fullName}
          </Text.Normal>
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={3} paddingX="s4">
        <Text.Normal size="200" weight="medium">
          {membership.createdAt
            ? i18nDateToString(stringToDate(membership.createdAt, 'backend_datetime'), 'ui')
            : ''}
        </Text.Normal>
      </Table.Cell>
      <Table.Cell colSpan={2} paddingX="s4">
        <Box flexDirection="row">
          {isOwner ? (
            <Tag type={Tag.Types.grey} leftItem="circle">
              {i18n.t('banking.account_memberships.status.owner')}
            </Tag>
          ) : (
            <Tag type={tagColor} leftItem="circle">
              {statusTagLabel(membership.status)}
            </Tag>
          )}
        </Box>
      </Table.Cell>
      <Table.Cell colSpan={1} paddingX="s4">
        <MembershipActionsMenu actions={actions} onAction={onAction} disabled={actionDisabled} />
      </Table.Cell>
    </Table.Row>
  )
}
